import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  ORDERS_FEATURE_KEY,
  ordersAdapter,
  OrdersPartialState,
  OrdersState,
} from './orders.reducer';

// Lookup the 'Orders' feature state managed by NgRx
export const getOrdersState = createFeatureSelector<
  OrdersPartialState,
  OrdersState
>(ORDERS_FEATURE_KEY);

const { selectAll, selectEntities } = ordersAdapter.getSelectors();

export const getOrdersLoaded = createSelector(
  getOrdersState,
  (state: OrdersState) => state.loaded
);

export const getOrdersError = createSelector(
  getOrdersState,
  (state: OrdersState) => state.error
);

export const getAllOrders = createSelector(
  getOrdersState,
  (state: OrdersState) => selectAll(state)
);

export const getOrdersEntities = createSelector(
  getOrdersState,
  (state: OrdersState) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getOrdersState,
  (state: OrdersState) => state.selectedId
);

export const getSelected = createSelector(
  getOrdersEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const getLocations = createSelector(
  getOrdersState,
  (state: OrdersState) => state.locations
);

export const getAddingOrUpdatingEvent = createSelector(
  getOrdersState,
  (state: OrdersState) => state.addingOrUpdatingEvent
);

export const getOrderDirection = createSelector(
  getOrdersState,
  (state: OrdersState) => state.orderDirection
);

export const getLocationType = createSelector(
  getOrdersState,
  (state: OrdersState) => state.locationType
);

export const getSelectedLocationIds = createSelector(
  getOrdersState,
  (state: OrdersState) => state.locationIds
);

export const getOrderHandShake = createSelector(
  getOrdersState,
  (state: OrdersState) => state.handShake
);

export const getSelectedCustomerIds = createSelector(
  getOrdersState,
  (state: OrdersState) => state.customerIds
);
export const getSelectedDateRange = createSelector(
  getOrdersState,
  (state: OrdersState) => state.dateRange
);

export const getQuery = createSelector(
  getOrdersState,
  (state: OrdersState) => state.query
);

export const getNextPage = createSelector(
  getOrdersState,
  (state: OrdersState) => state.nextPage
);

export const messages = createSelector(
  getOrdersState,
  (state: OrdersState) => state.messages
);

export const getStatus = createSelector(
  getOrdersState,
  (state: OrdersState) => state.statuses
);
